const s = "v1/applePay/sessions";
export { s as APPLEPAY_SESSION_ENDPOINT };
